import React from 'react';
import { PageHeader } from 'antd';
import { MyBreadcrumb } from 'utils';
import CategoriesForm from './form';
export default function CategoriesUpdate(props) {
    const { id } = props.match.params;
    return (
        <div>
            <MyBreadcrumb items={[{
                label: "Categories", path: "/knowledge-base/categories"
            }, { label: "Update", path: "" }]} />
            <PageHeader
                ghost={false}
                onBack={() => window.history.back()}
                title="Update"
                subTitle=""
            >
                <CategoriesForm id={id} type={props.match.params.type} />
            </PageHeader>
        </div>
    );
}